import { render } from "./EmployeeSettingProfiles.vue?vue&type=template&id=e5ebde24"
import script from "./EmployeeSettingProfiles.vue?vue&type=script&lang=js"
export * from "./EmployeeSettingProfiles.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__